import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import Clarity from '@microsoft/clarity';
import { SentryService } from '../sentry/sentry.service';

@Injectable({
  providedIn: 'root'
})
export class ClarityService {
  constructor(
    private sentryService: SentryService
  ) { }

  /**
   * Inicializa Clarity con el ID del proyecto.
   */
  initClarity(): void {
    try {
      // solo environment prod
      if (!environment.production) return;
      const projectId = "kvnu0qwjjf";
      Clarity.init(projectId);
    } catch (err) {
      console.error(err);
      this.sentryService.captureException(err);
    }
  }

  /**
   * Envía un evento a Clarity.
   */
  sendEvent(event: string): void {
    try {
      if (!event) return;
      Clarity.event(event);
    } catch (error) {
      console.error('Error sending event to Clarity:', error);
      this.sentryService.captureException(error);
    }
  }
}